/**
 * @author Kelnik
 *
 * ProgressYears - на стр. ход строительства
 */

import axios from 'axios';
import Observer from 'common/scripts/observer';
import tmplSlider from './templates/slider.twig';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class ProgressYears {
    constructor() {
        this.containerSelector = '.j-progress-years';
        this.container = document.querySelector(this.containerSelector);
        this.linkSelector = '.j-progress-years-link';
        this.sliderSelector = '.j-progress-years-slider';
        this.slideSelector = '.j-residential-slide';

        // Кол-во отправленных запросов на бек
        this.countReq = 0;
        // Данные от запроса
        this.data = {};
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._bindEvents();
        this._displayFirstData();
    }

    _initElements() {
        this.links = Array.from(this.container.querySelectorAll(this.linkSelector));
        this.slider = this.container.querySelector(this.sliderSelector);
    }

    _bindEvents() {
        this.links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const data = this._datasetToFormData(link);

                this._setActive(link, this.links);
                this._send(data);
            });
        });

        observer.subscribe('progress-gallery:change-month', (id) => {
            const slide = this._getActiveMonthElementById(id);

            this._changeMonth(slide, 0);
        });

        this._bindAfterAjax();
    }

    _bindAfterAjax() {
        this.slides = Array.from(this.container.querySelectorAll(this.slideSelector));

        this.slides.forEach((slide) => {
            slide.addEventListener('click', (event) => {
                event.preventDefault();

                this._changeMonth(slide);
            });
        });
    }

    _datasetToFormData(element) {
        const formData = new FormData();
        const dataset = element.dataset;

        for (const key in dataset) {
            if (Object.prototype.hasOwnProperty.call(dataset, key)) {
                formData.append(key, dataset[key]);
            }
        }

        return formData;
    }

    _displayFirstData() {
        const dataJson = this.container.dataset.json;

        if (!dataJson) {
            const currentYear = this._getCurrentYear();
            const data = this._datasetToFormData(currentYear);

            this._send(data);

            return;
        }

        const data = JSON.parse(Utils.fromBase64(dataJson));

        this.data = data.data;

        this._processingData(data.data);
    }

    _send(data) {
        const action = this.container.dataset.action;
        const method = this.container.dataset.method;

        this.countReq = this.countReq + 1;
        this._onLoadSlider();

        axios[method](action, data)
            .then((response) => {
                this.countReq = this.countReq - 1;

                if (this.countReq > 0) {
                    return;
                }

                const sendData = response.data.data;

                this.data = sendData;

                this._processingData(sendData);
            })
            .catch((error) => {
                this.countReq = this.countReq - 1;

                console.error(error); // eslint-disable-line
            })
            .then(() => {
                if (this.countReq <= 0) {
                    this._offLoadSlider();
                }
            });
    }

    _processingData(data) {
        if (data.months && typeof data.months === 'object') {
            data.months = Object.values(data.months);
        }

        Array.from(data.months).forEach((month) => {
            month.active = false;
        });

        data.months[0].active = true;

        this._replaceSlider(data);
        this._bindAfterAjax();

        const activeMonth = this._getActiveData();

        this._publishMonth(activeMonth);
    }

    _setActive(current, elements) {
        elements.forEach((link) => {
            if (link === current) {
                link.classList.add('is-active');
            } else {
                link.classList.remove('is-active');
            }
        });
    }

    _setActiveById(id, elements) {
        elements.forEach((element) => {
            element.active = Number(id) === Number(element.id);
        });
    }

    _changeMonth(month, duration = 300) {
        observer.publish('progress-year:before-month');

        setTimeout(() => {
            const id = month.dataset.id;
            const currentData = this._getCurrentDataById(id);

            this._setActive(month, this.slides);

            if (this.data && this.data.months) {
                this._setActiveById(id, this.data.months);
            }

            this._publishMonth(currentData);
        }, duration);
    }

    _publishMonth(data) {
        const sendData = {
            ...this.data,
            month      : data,
            another    : this._getAnotherMonths(),
            activeIndex: this._getIndexActiveMonth()
        };

        observer.publish('progress-year:change-month', sendData);
    }

    _getCurrentYear() {
        return this.links.find((link) => {
            return link.classList.contains('is-active');
        });
    }

    _getActiveData() {
        if (!this.data || !this.data.months || !this.data.months.length) {
            return null;
        }

        return this.data.months.find((month) => {
            return month.active;
        });
    }

    _getCurrentDataById(id) {
        if (!this.data || !this.data.months || !this.data.months.length) {
            return null;
        }

        return this.data.months.find((month) => {
            return Number(month.id) === Number(id);
        });
    }

    _getAnotherMonths() {
        if (!this.data || !this.data.months || !this.data.months.length) {
            return null;
        }

        return this.data.months.filter((month) => {
            return !month.active;
        });
    }

    _getIndexActiveMonth() {
        let index = null;

        this.data.months.forEach((month, key) => {
            if (month.active) {
                index = key;
            }
        });

        return index;
    }

    _getActiveMonthElementById(id) {
        return this.slides.find((slide) => {
            return Number(slide.dataset.id) === Number(id);
        });
    }

    _replaceSlider(data) {
        Utils.clearHtml(this.slider);

        if (data.months && data.months.length <= 1) {
            return;
        }

        this.slider.insertAdjacentHTML('beforeend', tmplSlider(data));

        observer.publish('lazyLoad:refresh', this.slider);
        observer.publish('residential-list:refresh', this.slider);
    }

    _onLoadSlider() {
        this.slider.classList.add('is-loading');
    }

    _offLoadSlider() {
        this.slider.classList.remove('is-loading');
    }
}

new ProgressYears().init();
